import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (data) => axios.post(`${API}/leads`, data);

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password });

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export const fetchLeads = (token, status) =>
  axios.get(`${API}/leads`, {
    headers: authHeaders(token),
    params: status && status !== "all" ? { status } : {},
  });

export const updateLeadStatus = (token, id, status) =>
  axios.patch(`${API}/leads/${id}`, { status }, { headers: authHeaders(token) });

export const deleteLead = (token, id) =>
  axios.delete(`${API}/leads/${id}`, { headers: authHeaders(token) });
